var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportViewAdendasJugadores',{attrs:{"path":_vm.path,"excelPath":_vm.excelPath,"filterPath":_vm.filterPath,"filenamePrefix":_vm.filenamePrefix}})}
var staticRenderFns = []

export { render, staticRenderFns }